module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-74-min.cf1b15d0.jpg";